<template>
  <b-row
    class="padding--x py-2 d-flex justify-content-between align-items-center navbar__container"
  >
    <b-col cols="3" class="p-0"
      ><a href="https://getboarded.com/">
        <img
          class="company-logo"
          :src="require(`@/assets/images/logo/logo.svg`)"
          alt="logo"
        /> </a
    ></b-col>
    <b-col class="d-flex align-items-center justify-content-end pr-0">
      <!-- <div
        @click="changeTheme"
        class="cursor-pointer d-flex align-items-center justify-content-center mx-1 mx-md-2"
      >
        <feather-icon
          :color="orgColor"
          :size="isDeviceSmall ? '25' : '35'"
          :icon="`${currentTheme === 'light' ? 'Sun' : 'Moon'}Icon`"
        />
      </div> -->

      <unified-menu class="mr-50" v-if="isUserLoggedIn" />

      <img
        v-if="isUserLoggedIn"
        variant="info"
        :src="getImg()"
        size="3.5em"
        class="ml-50 selected__img"
      />
      <div
        class="cursor-pointer d-flex d-md-none align-items-center justify-content-center ml-75"
        @click="
          $store.commit('modals/OPEN_EDITOR_POPUP', true);
          blockBodyScroll(true);
        "
      >
        <!-- <feather-icon
          :color="appView === 'organizationView' ? orgColor : '#e82b51'"
          :size="isDeviceSmall ? '27' : '32'"
          icon="UserIcon"
        /> -->
      </div>
    </b-col>
    <editor-modal v-if="editorPopup" :orgName="orgObj.orgName" />
  </b-row>
</template>

<script>
import constants from "@/constants";
import { BRow, BCol } from "bootstrap-vue";
import designMixin from "@/mixins/designMixin.js";
import orgMixin from "@/mixins/orgMixin.js";
import EditorModal from "@/modals/EditorModal.vue";
import UnifiedMenu from "./UnifiedMenu.vue";

export default {
  name: "Navbar",
  mixins: [orgMixin, designMixin],
  components: {
    BCol,
    BRow,

    EditorModal,
    UnifiedMenu,
  },
  data() {
    return {
      constants,
      orgColor: "",
    };
  },
  computed: {
    userAccessStatus() {
      return this.$store.state.user.userAccessStatus;
    },
    editorPopup() {
      return this.$store.state.modals.editorPopup;
    },
    appView() {
      return this.$store.state.user.appView;
    },
    userData() {
      return this.$store.state.user.userData;
    },
    avatarNameGenerator() {
      return this.$store.state.user.avatarNameGenerator;
    },
    isUserLoggedIn() {
      return this.$store.state.auth.isUserLoggedIn;
    },
  },
  created() {
    this.orgColor = this.orgObj.orgColor;
    const { gbuid, gborgid } = this.$route.query;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "gtm.load",
      userId: gbuid,
      orgId: gborgid,
    });
  },
  methods: {
    getImg() {
      if (this.userData && this.userData.profilePictureUrl) {
        return `${constants.s3Bucket}/editor/profile-pictures/${this.userData.profilePictureUrl}`;
      } else {
        let firstName =
          this.userData && this.userData.firstName
            ? this.userData.firstName
            : "boringAvatar";
        let lastName =
          this.userData && this.userData.lastName
            ? this.userData.lastName
            : "boringAvatar";
        return `https://source.boringavatars.com/beam/100/${this.avatarNameGenerator(
          firstName,
          lastName
        )}`;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/style.scss";
.navbar__container {
  // border-bottom: 2px solid $gray-300;
  background: #fff;
}

.selected__img {
  width: 3.25em;
  height: 3.25em;
  border-radius: 50%;
  object-fit: cover;
  &__org {
    object-fit: contain;
  }
}
.custom-btn {
  &__user-view {
    background: #e82b51;
  }
}
</style>
